import axios from "axios"
import { isAuthenticated, logout, getToken } from "./Auth";
const API_URL = process.env.REACT_APP_BASE_URL;

var axiosApi = axios.create({
  baseURL: API_URL,
})
axiosApi.interceptors.response.use(function (response) {
  const statusCode = response.data.statusCode;
  if(statusCode === 1500){
    logout()
    window.location = "/login"
    return response;
  }
  else{
    return response;
  }
}, function (error) {
  // Backend rejects expired/invalid tokens with 405 and inactive accounts with 401
  const status = error?.response?.status;
  if (status === 401 || status === 405) {
    logout();
    window.location = "/login";
  }
  return Promise.reject(error);
});

// Login Method
export const postLogin = (url, data) => {
  // return axios.post(API_URL+"en-us/admin"+url, data).then(response => {
  return axios.put(API_URL+url, data).then(response => {
      if (response.status === 400 || response.status === 500) {
          throw "Sorry! Something went wrong, please contact our support team";
      }
      if (!response.data.success) {
          throw "Please provide a valid email address and password";
      }
      return response.data;
  }).catch(err => {
      throw "Please provide a valid email address and password";
  });
}
export const forgotPassword = (url, data) => {
  return axios.post(API_URL+"en-us/admin"+url, data).then(response => {
      if (!response.data.status) {
        throw "Sorry! Something went wrong, please contact our support team";
      }
      return response.data;
  }).catch(err => {
      throw "Sorry! Something went wrong, please contact our support team";
  });
}
export const resetPassword = (url, data) => {
  return axios.post(API_URL+"en-us/admin"+url, data).then(response => {
      if (!response.data.status) {
        throw "Sorry! Something went wrong, please contact our support team";
      }
      return response.data;
  }).catch(err => {
      throw "Sorry! Something went wrong, please contact our support team";
  });
}

export async function apiWrapper(callback , url, data = {},config = {},locale = ""){
  if(isAuthenticated()){
    return callback(url,data,config, "Bearer "+getToken());
  }
  else{
    logout();
    window.location = "/login";
  }
}


export async function get(url, params = {}, config = {}, token) {
  axiosApi.defaults.headers.common["token"] = await token.replace("Bearer ", "");;
  let p = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  return axiosApi.get(url+"?"+p, { ...config });
}

export async function post(url, data = {}, config = {}, token) {
  axiosApi.defaults.headers.common["token"] = await token.replace("Bearer ", "");;
  // let configuration = { headers: { 'content-type': 'multipart/form-data' } }
  console.log("config post", config)
  return axiosApi.post(url, { ...data }, config );
}

export async function postForm(url, formData, headers = {}, token) {
  axiosApi.defaults.headers.common["token"] = await token.replace("Bearer ", "");;
  let configuration = { headers: { 'content-type': 'multipart/form-data', ...headers } }
  console.log('configuration', configuration)
  return axiosApi.post(url, formData, configuration);
}

export async function put(url, data, config = {}, token) {
  axiosApi.defaults.headers.common["token"] = await token;
  axiosApi.defaults.headers.common["token"] = await token.replace("Bearer ", "");
  return axiosApi.put(url, { ...data }, { ...config });
}

export async function putForm(url, formData, headers = {}, token) {
  axiosApi.defaults.headers.common["token"] = await token.replace("Bearer ", "");;
  let configuration = { headers: { 'content-type': 'multipart/form-data', ...headers } }
  return axiosApi.put(url, formData, configuration);
}

export async function del(url, data = {}, config = {}, token) {
  axiosApi.defaults.headers.common["Authorization"] = await token;
  axiosApi.defaults.headers.common["token"] = await token.replace("Bearer ", "");
  return await axiosApi.delete(url, { data : { ...data } , ...config });
}